import { render, staticRenderFns } from "./PersonalTotpSettings.vue?vue&type=template&id=032d7d0a&scoped=true&"
import script from "./PersonalTotpSettings.vue?vue&type=script&lang=js&"
export * from "./PersonalTotpSettings.vue?vue&type=script&lang=js&"
import style0 from "./PersonalTotpSettings.vue?vue&type=style&index=0&id=032d7d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032d7d0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.7m6CVIT2x327/twofactor_totp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032d7d0a')) {
      api.createRecord('032d7d0a', component.options)
    } else {
      api.reload('032d7d0a', component.options)
    }
    module.hot.accept("./PersonalTotpSettings.vue?vue&type=template&id=032d7d0a&scoped=true&", function () {
      api.rerender('032d7d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PersonalTotpSettings.vue"
export default component.exports